import React, { forwardRef } from "react";
import { DateTime } from "luxon";
import { Row } from "react-bootstrap";

const ZonedTimeInput = forwardRef<
    HTMLInputElement,
    {
        value?: string;
        onChange?: (value: string) => void;
        disabled?: boolean;
        timeZone: string;
        selectedDate: Date | null;
    }
>(({ value, onChange, disabled, timeZone, selectedDate }, ref) => {
    const localTime = value || (selectedDate ? DateTime.fromJSDate(selectedDate).toFormat("HH:mm") : "");
    const zonedTime = selectedDate
        ? DateTime.fromJSDate(selectedDate, { zone: timeZone }).setZone(timeZone).toFormat("HH:mm")
        : localTime;

    const handleChange = (newTime: string) => {
        if (onChange) {
            const parsedTime = DateTime.fromFormat(newTime, "HH:mm", { zone: timeZone });
            if (parsedTime.isValid && selectedDate) {
                const newDate = DateTime.fromJSDate(selectedDate, { zone: timeZone })
                    .set({ hour: parsedTime.hour, minute: parsedTime.minute })
                    .toJSDate();
                onChange(DateTime.fromJSDate(newDate).toFormat("HH:mm"));
            }
        }
    };

    return (
        <Row className="react-datepicker__input-time-wrapper">
            <input
                ref={ref}
                type="time"
                value={zonedTime}
                onChange={(e) => handleChange(e.target.value)}
                disabled={disabled}
                className="react-datepicker-time__input custom-time-input"
            />
        </Row>
    );
});
ZonedTimeInput.displayName = "ZonedTimeInput";

export default React.memo(ZonedTimeInput);
